import _ from 'underscore';

import {getDashEntityName, getDashLabel} from './dashboard-constants';

function getMetricSubheader(baseLabel, dash) {
    const dashDataObject = dash.data.dashboardMetrics[0];
    if (!dashDataObject) {
        return baseLabel;
    }

    return `${baseLabel} - ${dashDataObject.periodDisplayString}`;
}

function getLeaderboardSubheader(baseLabel, dash) {
    const leaderboardType = dash.data.leaderboardType === 'activities' ? 'Activity' : 'Sales';

    const periodDisplayString = dash.data.periodDisplayString;

    return `${leaderboardType} ${baseLabel} - ${periodDisplayString}`;
}

function getListSubheader(baseLabel, dash) {
    if (!dash.data.list) {
        return baseLabel;
    }
    const listType = getListTypeString(dash.data.list.reportType);

    return `${listType} ${baseLabel}`;
}

export function getListTypeString(reportType) {
    switch (reportType) {
        case 'entity_list_leads':
            return 'Leads';
        case 'entity_list_accounts':
            return 'Companies';
        case 'entity_list_contacts':
            return 'People';
    }
}

export function getListFieldKey(reportType) {
    switch (reportType) {
        case 'entity_list_leads':
            return 'leads';
        case 'entity_list_accounts':
            return 'accounts';
        case 'entity_list_contacts':
            return 'contacts';
    }
}

export function getDashSubheader(dash) {
    const entityName = getDashEntityName(dash.type);
    const baseLabel = getDashLabel(dash.type);

    if (_.isEmpty(dash.data)) {
        return baseLabel;
    }

    if (entityName === 'dashboardMetrics') {
        return getMetricSubheader(baseLabel, dash);
    } else if (entityName === 'leaderboards') {
        return getLeaderboardSubheader(baseLabel, dash);
    } else if (entityName === 'lists') {
        return getListSubheader(baseLabel, dash);
    } else if (entityName === 'funnel') {
        // Temporarily overriding the subheader of all 'funnel' cards (which
        // are really 'pipeline' cards) because the visualization of one's
        // pipeline by stage is the _only_ visualization we have right now.
        // Eventually, we'd like to see more visualizations (Pipeline by Close
        // Date, Pipeline by Assignee, etc.), and when those changes come our
        // subheader will be variant. But for now, this just gets the 'Pipeline
        // by Stage' subheader in line.  refs
        // https://nutshell.atlassian.net/browse/NUT-3826
        return `${dash.data.stagesetName} by stage`;
    } else {
        return baseLabel;
    }
}
